<template>
  <div
    :id="id"
    :class="[
      variants[variant]?.default,
      variants[variant]?.selected,
      variants[variant]?.classes,
      sizes[size],
      full && 'w-full',
      block && 'block',
    ]"
  >
    <div class="flex">
      <div>
        <component
          :is="GetVariantIcon()"
          :class="[variants[variant]?.icon]"
          class="h-5 w-5"
          aria-hidden="true"
        ></component>
      </div>
      <div :class="[variants[variant]?.header]" class="ml-3">
        <h3 class="text-sm font-medium">
          {{ title }}
        </h3>
        <div :class="[variants[variant]?.body]" class="mt-2 text-sm">
          <p>
            {{ message }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
//Icon
import { ExclamationIcon } from "@heroicons/vue/solid";
import { XCircleIcon } from "@heroicons/vue/solid";
import { CheckCircleIcon } from "@heroicons/vue/solid";
import { InformationCircleIcon } from "@heroicons/vue/solid";

//Types
import { SizesKeys } from "@/types/sizes.type";
import type { SizesKeysType } from "@/types/sizes.type";

import { variants, sizes, VariantKeys } from "./Alert";
import type { VariantsType } from "./Alert";

//Props
const props = withDefaults(
  defineProps<{
    id?: string;
    variant?: VariantsType;
    size?: SizesKeysType;
    full?: boolean;
    block?: boolean;
    title: string;
    message: string;
  }>(),
  {
    variant: VariantKeys.primary,
    size: SizesKeys.default,
    full: true,
    block: false,
    title: "",
    message: "",
  }
);

const GetVariantIcon = () => {
  const variantIcon = {
    [VariantKeys.primary]: undefined,
    [VariantKeys.secondary]: undefined,
    [VariantKeys.error]: XCircleIcon,
    [VariantKeys.warning]: ExclamationIcon,
    [VariantKeys.valid]: CheckCircleIcon,
    [VariantKeys.info]: InformationCircleIcon,
    [VariantKeys.none]: undefined,
  };
  return variantIcon?.[props.variant];
};
</script>
